export default __webpack_public_path__ + "locales/pt/BackupCodesDialog.json?hash=7589d1f48cc430843b41184076c481c3";